import React , {useEffect} from "react";
import "../../StyleComponents/Blog.css";
import Footer from "../Footer";
import Navbar from "../Navbar";
import ScrollHandler from "../ScrollHandler";
import reactBlogImage from "../../Assets/Images/blog-react-img.png";
import reactHumanHolding from "../../Assets/Images/humanReactjsimage.jpg";

function Reactjs() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <>
      <Navbar />
      <section id="Blog">
        <section className="Blog-Cards-Container">
          <div className="Blog-Cards">
            <section className="react-js">
              <header className="header">
                <h1>React Js</h1>
                <img src={reactBlogImage} alt="error loading image" />
              </header>
              <span className="Time">
                <p className="Month">January</p>
                <p className="Year">2023</p>
              </span>

              <section className="Full-Content-Container">
                <div className="heading">
                  <h1>
                    What is <h2 className="High-Lights">React Js</h2>
                  </h1>
                </div>
                <div className="Defination">
                  <p>
                    React.js, also known as React, is a popular open-source
                    JavaScript library used for building user interfaces.
                    Developed by Facebook, React allows developers to create
                    complex, dynamic, and responsive applications using a
                    component-based approach. React uses a virtual DOM (Document
                    Object Model) to update the user interface efficiently,
                    reducing the need for direct manipulation of the DOM. This
                    makes React fast, scalable, and easy to maintain. React can
                    be used with other libraries and frameworks, such as Redux
                    and Angular, and it has a large and active community of
                    developers who contribute to its development and share best
                    practices. React is widely used in web development, and it
                    has become an essential skill for front-end developers.
                  </p>
                </div>
                <div className="react-Sub-heading">
                  <h1>Top Trends of React In 2023</h1>

                  <div className="point-heading">
                    <h1>Growth in Number of Programmers that use ReactJS</h1>
                    <p>
                      As ReactJS is gaining popularity, the number of developers
                      that are adopting to it are expanding drastically. There
                      has been a steady increase in the adoption of React seen,
                      from 72% in 2018 to 80% in 2020, and there are no signs of
                      this trend slowing down. In 2023, the world will need a
                      staggeringly larger number of programmers. This is because
                      there has been an uptrend in the need for ReactJS
                      developers to provide enterprise solutions for businesses.
                    </p>
                  </div>

                  <div className="human-holding-react-content">
                    <header>
                      <h1>
                        Many companies and new ventures are choosing ReactJs as
                        their primary framework
                      </h1>
                    </header>
                    <div className="react-img-content">
                      <a href="https://react.dev/learn" target="_blank">
                        {" "}
                        <img
                          src={reactHumanHolding}
                          alt="error loading image."
                        />
                      </a>
                      <p>
                        The main objective of every company or startup is, of
                        course, to find ways to cut down on the expense of
                        creating innovative technological solutions. ReactJs has
                        shown promise over the past few years as a tool to help
                        organizations create high-performing web applications
                        for a reasonable price In 2021 and 2022, many
                        technologies were used, and among them, ReactJS proved
                        to be a dependable solution that provided numerous
                        development options. Businesses are under pressure to
                        find digital answers to pandemics, and ReactJS is
                        playing a bigger part in this as it allows them to push
                        their limits and see how well they measure up.
                      </p>
                    </div>

                    <div className="react-conclusion">
                      <p>
                        Therefore, If you’re looking for a JavaScript library to
                        employ in your next project, ReactJS is your best bet
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </div>
        </section>
      </section>

      <Footer />
      <ScrollHandler />
    </>
  );
}

export default Reactjs;
